import React from "react";
import { connect } from 'react-redux'
import { getStep } from '../../utils'
import StepRenderer from './step-renderer'
import Sign from '../../components/sign'
import FillQuestionnaire from '../../components/fill-questionnaire'
import AgentContracts from '../../components/agent-contracts'
import AgentCases from '../../components/agent-cases'
import AgentCaseDetails from '../../components/agent-case-details'
import { Provider } from 'react-redux'

import {
    HashRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";

class Tilbod extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Provider store={this.props.store} >
                <Router>
                    { this.props.signingOnly ?
                        <Switch>
                            <Route path="/sign/:token" render={(props) => <Sign {...props} user={this.props.user} signingOnly={this.props.signingOnly} />} />
                            <Route path="/fill/:token" render={(props) => <FillQuestionnaire {...props} signingOnly={this.props.signingOnly} />} />
                        </Switch>
                    :
                        <Switch>
                            <Route exact path="/" render={() => { return <Redirect to="/step/0" /> }} />
                            <Route path="/step/:stepnumber" render={(props) => <StepRenderer {...props} message={this.props.message} />} />
                            <Route path="/sign/:token" render={(props) => <Sign {...props} signingOnly={this.props.signingOnly} />} />
                            <Route path="/fill/:token" render={(props) => <FillQuestionnaire {...props} />} />
                            <Route path="/contracts" render={(props) => <AgentContracts {...props} />} />
                            <Route 
                                path="/cases/:caseId" 
                                render={(props) => <AgentCaseDetails {...props} 
                                    caseId={props.match && props.match.params ? props.match.params.caseId : null} 
                                    advisorFullName={this.props.userFullName}
                                />}
                            />
                            <Route exact path="/cases" render={(props) => <AgentCases {...props} />} />
                        </Switch>
                    }
                </Router>
            </Provider>
        )
    }
}

function mapStateToProps(state) {

    var f = {
        gui: {},
        offers: {},
    }
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.offers = (state.offers === undefined) ? {} : state.offers
    return f;
}

export default connect(mapStateToProps)(Tilbod);
